import React from 'react';

const LoadingIndicator = () => (
  <div className="user-page__loading">
    <div className="spinner"></div>
    <p>Finding the best legal professionals for you...</p>
  </div>
);

export default LoadingIndicator; 